module.exports = __webpack_public_path__ + "img/login-img.4c174476.jpg";